/* =========================================================
   PRO TUNE — comportamentos que antes ficavam dentro de arquivos do Horizon
   (product-form.js, video-background.js, blocks/menu.liquid)
   ========================================================= */
(function () {
  'use strict';

  // 1) Depois de adicionar ao carrinho pela página de produto, vai direto para o carrinho
  document.addEventListener('cart:update', function (e) {
    var d = e && e.detail && e.detail.data;
    if (d && d.source === 'product-form-component' && !d.didError) {
      window.location.href = '/cart';
    }
  });

  // 2) Vídeos de fundo (header da home): força o autoplay
  function playBgVideos() {
    document.querySelectorAll('video-background-component video').forEach(function (v) {
      v.muted = true;
      v.setAttribute('playsinline', '');
      if (v.paused) {
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
        v.addEventListener('canplay', function () {
          if (v.paused) { var q = v.play(); if (q && q.catch) q.catch(function () {}); }
        }, { once: true });
      }
    });
  }

  // 3) Link do Performance Cloud no menu abre em nova aba
  function externalMenuLinks() {
    document.querySelectorAll('a[href*="performance.protune.com.br"]').forEach(function (a) {
      a.setAttribute('target', '_blank');
      a.setAttribute('rel', 'noopener noreferrer');
    });
  }

  function init() { playBgVideos(); externalMenuLinks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', playBgVideos);
  document.addEventListener('shopify:section:load', init);
})();

/* 4) Menu "Escolher": miniaturas das ECUs / TDLs ao passar o mouse
      (conteúdo vem de snippets/protune-menu-thumbs.liquid) */
(function () {
  'use strict';
  var MAP = {
    '/pages/qual-ecu-escolher': 'ecu',
    '/pages/qual-tdl-painel-escolher': 'tdl'
  };
  function keyOf(a) {
    try { return MAP[new URL(a.href, location.origin).pathname]; } catch (e) { return null; }
  }
  function show(grid, key) {
    var tpl = document.getElementById('protune-menu-thumbs-' + key);
    if (!grid || !tpl) return;
    var box = grid.querySelector(':scope > .protune-menu-thumbs');
    if (!box) {
      box = document.createElement('div');
      box.className = 'protune-menu-thumbs';
      box.setAttribute('aria-hidden', 'true');
      grid.appendChild(box);
    }
    if (box.dataset.key !== key) {
      box.innerHTML = tpl.innerHTML;
      box.dataset.key = key;
    }
  }
  function handle(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    // passou o mouse num dos links "Qual ... escolher"
    var link = t.closest('.mega-menu__link');
    if (link) {
      var k = keyOf(link);
      if (k) {
        var g = link.closest('.mega-menu__grid');
        show(g, k);
        g.querySelectorAll('.mega-menu__link').forEach(function (a) {
          a.classList.toggle('is-active-category', a === link);
        });
      }
      return;
    }
    // passou o mouse só em "Escolher" (menu de cima): mostra ECUs e TDLs juntos
    var item = t.closest('.menu-list__list-item');
    if (item && t.closest('.menu-list__link')) {
      var links = item.querySelectorAll('.mega-menu__link');
      for (var i = 0; i < links.length; i++) {
        if (keyOf(links[i])) {
          show(links[i].closest('.mega-menu__grid'), 'all');
          links.forEach(function (a) { a.classList.remove('is-active-category'); });
          break;
        }
      }
    }
  }
  document.addEventListener('pointerover', handle);
  document.addEventListener('focusin', handle);
})();

/* 5) Submenus alinhados com o primeiro item do menu de cima ("Produtos"),
      em qualquer largura de tela (antes era 17% fixo e ficava à esquerda do logo) */
(function () {
  'use strict';
  var LINK_PADDING = 12; // recuo interno dos links do submenu (protune-custom.css)
  function align() {
    if (window.innerWidth < 750) return;
    var first = document.querySelector('.header-menu .menu-list__list-item:not([slot="overflow"]) .menu-list__link-title');
    if (!first) return;
    var start = first.getBoundingClientRect().left + parseFloat(getComputedStyle(first).paddingLeft || 0);
    document.querySelectorAll('.menu-list__submenu .mega-menu__grid').forEach(function (grid) {
      grid.style.removeProperty('padding-left');
      var left = grid.getBoundingClientRect().left;
      var pad = Math.max(16, Math.round(start - left - LINK_PADDING));
      grid.style.setProperty('padding-left', pad + 'px', 'important');
    });
  }
  var t;
  function later() { clearTimeout(t); t = setTimeout(align, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', align); else align();
  window.addEventListener('load', align);
  window.addEventListener('resize', later);
  document.addEventListener('pointerover', function (e) {
    if (e.target && e.target.closest && e.target.closest('.header-menu .menu-list__link')) align();
  });
})();
